import { render, staticRenderFns } from "./InfoBase.vue?vue&type=template&id=04c2d218"
import script from "./InfoBase.vue?vue&type=script&lang=js"
export * from "./InfoBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04c2d218')) {
      api.createRecord('04c2d218', component.options)
    } else {
      api.reload('04c2d218', component.options)
    }
    module.hot.accept("./InfoBase.vue?vue&type=template&id=04c2d218", function () {
      api.rerender('04c2d218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/formalizacionactas/infoBase/InfoBase.vue"
export default component.exports